import { useContext, ref, reactive } from "@nuxtjs/composition-api";
import useVuelidate from "@vuelidate/core";
import { useSendPasswordRecovery } from "../auth";

const initialFormData = () => ({
  email: "",
});

export function usePasswordRecoveryForm(context) {
  const {
    $validation: { rules },
    $logger,
  } = useContext();
  const submitting = ref(false);
  const formData = reactive(initialFormData());
  const sendPasswordRecovery = useSendPasswordRecovery();

  function resetForm() {
    Object.assign(formData, initialFormData());
  }

  const validationArgs = {
    email: {
      required: rules.required,
      email: rules.email,
      maxLength: rules.maxLength(100),
    },
  };

  const v$ = useVuelidate(validationArgs, formData, {
    $lazy: true,
    $stopPropagation: true,
  });

  async function submit() {
    try {
      submitting.value = true;

      const isValid = await v$.value.$validate();
      if (!isValid) {
        return;
      }

      await sendPasswordRecovery({
        email: formData.email.toLowerCase().trim(),
      });

      context.emit("submitted");
    } catch (e) {
      $logger.error(e);
    } finally {
      submitting.value = false;
    }
  }

  return {
    submitting,
    formData,
    resetForm,
    v$,
    submit,
  };
}
